var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(-1 0 0 1 13 2)",
    fill: "#222223"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(-1 0 0 1 13 17)",
    fill: "#333333",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.95,
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 8 3)",
    fill: "#333333",
    fillOpacity: 0.95
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 15.5 15.9904)",
    fill: "#333333",
    fillOpacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 4 6)",
    fill: "#333333",
    fillOpacity: 0.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 16.9904 13.5)",
    fill: "#333333",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 2 11)",
    fill: "#333333",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 17 11)",
    fill: "#333333",
    fillOpacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 3 16)",
    fill: "#333333",
    fillOpacity: 0.7
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 15.9904 8.5)",
    fill: "#333333",
    fillOpacity: 0.05
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    rx: 1,
    transform: "matrix(0.866025 0.5 0.5 -0.866025 6 20)",
    fill: "#333333",
    fillOpacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static-bigflip/media/Spinner.bb6dcd5c.svg";
export { ForwardRef as ReactComponent };